module.exports = __webpack_public_path__ + "static/media/SLT.454d1671.jpeg";